import { Branch } from '@basehub/data/replicache/index'
import { useCRMetadata } from '../_hooks/use-cr-metadata'
import { useBranchMergeDiff } from '../_hooks/use-merge-diff'
import { MergeIcon } from '~/components/icons/branch-icon'
import { BranchLink } from './branch-actions-cta'
import { formatToSpecific } from '~/lib/time/utils'
import { SimpleTooltip } from '~/sotano-kit/primitives/tooltip'
import { EventLayout } from './branch-timeline'
import { clsx } from 'clsx'
import { ArchiveIcon } from '~/components/icons/archive'

export const BranchSummary = ({ branch }: { branch: Branch }) => {
  const { baseBranch } = useBranchMergeDiff({ branch })
  const { data } = useCRMetadata({ branch })

  let icon: React.ReactNode
  let title: React.ReactNode
  let right: React.ReactNode
  let className = ''

  if ((data?.ahead ?? 0) > 0) {
    icon = (
      <div className="bg-blue absolute inset-0 flex items-center justify-center rounded-full">
        <MergeIcon />
      </div>
    )
    title = (
      <>
        This branch has been merged to <BranchLink branch={baseBranch} />.
      </>
    )
    className = 'bg-blue'
    if (branch.headCommit) {
      const mergedAt = new Date(branch.headCommit.createdAt)

      right = (
        <SimpleTooltip content={formatToSpecific(mergedAt)}>
          <div className="text-dark-bright/70 cursor-default">
            on{' '}
            {mergedAt.toLocaleDateString('en-US', {
              month: 'long',
              year: 'numeric',
              day: 'numeric',
            })}
          </div>
        </SimpleTooltip>
      )
    }
  } else if (branch.archivedAt) {
    icon = (
      <div>
        <ArchiveIcon />
      </div>
    )
    title = <>This branch was archived</>
    className = 'bg-dark-shade'
  }

  return (
    <EventLayout icon={icon}>
      <div
        className={clsx(
          'border rounded-lg border-dark-border-solid overflow-hidden mt-[-13px]',
          className
        )}
      >
        <div className="px-4 py-3 flex items-center gap-2 justify-between text-sm">
          <div className="font-medium">{title}</div>
          <div>{right}</div>
        </div>
      </div>
    </EventLayout>
  )
}
